export const Physical_Address_Data = [
  {
    id: 10,
    label: "All tiers with street & city, state or postal code, & country",
    score: 10,
  },
  {
    id: 9,
    label: "All tiers with state or postal code & country",
    score: 9,
  },
  {
    id: 8,
    label: "All tiers with country",
    score: 8,
  },
  {
    id: 7,
    label: "Up to n-1 tiers with street, state or postal code, & country",
    score: 7,
  },
  {
    id: 6,
    label: "Up to n-1 tiers with state or postal code & country",
    score: 6,
  },
  {
    id: 5,
    label: "Up to n-1 tiers with country",
    score: 5,
  },
  {
    id: 4,
    label: "Less than n-1 tiers with street, state or postal code, & country",
    score: 4,
  },
  {
    id: 3,
    label: "Less than n-1 tiers with state or postal code & country",
    score: 3,
  },
  {
    id: 2,
    label: "Less than n-1 tiers with country",
    score: 2,
  },
  {
    id: 1,
    label:
      "Only supplier tier or any tier information provided (at least one node)",
    score: 1,
  },
  {
    id: 0,
    label: "Declined to submit, insufficient info to score, etc.",
    score: 0,
  },
];

export const GPS_Address_Data = [
  {
    id: 10,
    label:
      "All tiers with Latitude & Longitude, state or postal code, & country",
    score: 10,
  },
  {
    id: 9,
    label: "Not Applicable to score for GPS Address",
    score: 9,
  },
  {
    id: 8,
    label: "Not Applicable to score for GPS Address",
    score: 8,
  },
  {
    id: 7,
    label:
      "Up to n-1 with Latitude & Longitude, state or postal code, & country",
    score: 7,
  },
  {
    id: 6,
    label: "Not Applicable to score for GPS Address",
    score: 6,
  },
  {
    id: 5,
    label: "Not Applicable to score for GPS Address",
    score: 5,
  },
  {
    id: 4,
    label:
      "Less than n-1 with Latitude & Longitude, state or postal code, & country",
    score: 4,
  },
  {
    id: 3,
    label: "Not Applicable to score for GPS Address",
    score: 3,
  },
  {
    id: 2,
    label: "Not Applicable to score for GPS Address",
    score: 2,
  },
  {
    id: 1,
    label:
      "Only supplier tier or any tier information provided (at least one node)",
    score: 1,
  },
  {
    id: 0,
    label: "Declined to submit, insufficient info to score, etc.",
    score: 0,
  },
];

export const Fishing_Address_Data = [
  {
    id: 10,
    label:
      "Vessel Name, Vessel Flag State, Fleet Owner Name, Fleet Owner Nationality, IMO Number or MMSI Number or IRCS Number",
    score: 10,
  },
  {
    id: 9,
    label:
      "Vessel Name, Vessel Flag State, IMO Number or MMSI Number or IRCS Number",
    score: 9,
  },
  {
    id: 8,
    label: "Vessel Name, Vessel Flag State",
    score: 8,
  },
  {
    id: 7,
    label:
      "Up to n-1 tiers with street, state or postal code, & country or Latitude & Longitude, state or postal code, & country",
    score: 7,
  },
  {
    id: 6,
    label: "Up to n-1 tiers with state or postal code & country",
    score: 6,
  },
  {
    id: 5,
    label: "Up to n-1 tiers with country",
    score: 5,
  },
  {
    id: 4,
    label:
      "Less than n-1 tiers with street, state or postal code, & country or Latitude & Longitude, state or postal code, & country",
    score: 4,
  },
  {
    id: 3,
    label: "Less than n-1 tiers with state or postal code & country",
    score: 3,
  },
  {
    id: 2,
    label: "Less than n-1 tiers with country",
    score: 2,
  },
  {
    id: 1,
    label:
      "Only supplier tier or any tier information provided (at least one node)",
    score: 1,
  },
  {
    id: 0,
    label: "Declined to submit, insufficient info to score, etc.",
    score: 0,
  },
];
